export default __webpack_public_path__ + "static/media/icn_minimum_order_value.bfa1b292.svg";